import { useToast } from 'primevue/usetoast'
import type { ToastParameters } from '../interfaces/toast.interface'
import { TOAST_DURATION } from '@/modules/core/constants/ui.constants.ts'

export function useToastComposable() {
  const toast = useToast()

  const showToast = (params: ToastParameters) => {
    toast.add(params)
  }

  const showToastSuccess = (summary: string, detail: string | null = null) => {
    toast.add({
      severity: 'success',
      summary: summary,
      detail: detail ?? '',
      life: TOAST_DURATION,
    })
  }

  const showToastError = (summary: string, detail: string | null = null) => {
    toast.add({
      severity: 'error',
      summary: summary,
      detail: detail,
      life: TOAST_DURATION,
    })
  }

  const showToastWarn = (summary: string, detail: string | null = null) => {
    toast.add({
      severity: 'warn',
      summary: summary,
      detail: detail,
      life: TOAST_DURATION,
    })
  }

  return { showToast, showToastSuccess, showToastError, showToastWarn }
}
